import { Hero } from '@/components/Hero';
import { Features } from '@/components/Features';
import { ProductShowcase } from '@/components/ProductShowcase';
import { WhyChooseUs } from '@/components/WhyChooseUs';
import { CTASection } from '@/components/CTASection';
import { Newsletter } from '@/components/Newsletter';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ProductShowcase />
      <Features />
      <WhyChooseUs />
      <CTASection />
      <Newsletter />
    </main>
  );
}
